<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">{{ formTitle }}</h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout text-center">
                <div class="md-layout-item md-size-100 md-xsmall-size-100">
                  <ckeditor
                    :editor="editor"
                    v-model="contentHtml"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
              </div>
            </md-card-content>

            <md-card-actions
              class="text-center"
              style="justify-content: center!important;"
            >
              <md-button type="submit" class="md-success"
                >{{ $t("common.save") }}
              </md-button>
            </md-card-actions>
          </md-card>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import CkeditorUploadAdapter from "@/helpers/ckeditor-upload-adapter";
import { AboutsService } from "../../../services/abouts.service";

export default {
  name: "MethodologyUniversityIndex",
  data() {
    return {
      formTitle: this.$t("page_title.manage_methodology_university"),
      editor: DecoupledEditor,
      contentHtml: null,
      editorConfig: {
        fontSize: {
          options: [
            8,
            9,
            10,
            11,
            12,
            13,
            "default",
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            24,
            26,
            28,
            36,
            48
          ],
          supportAllValues: true
        },
        extraPlugins: [this.uploader],
        language: "vi"
      }
    };
  },
  created() {
    this.getDetailMethodologyProgram();
  },
  methods: {
    async getDetailMethodologyProgram() {
      const info = await new AboutsService().getList({
        type: "methodology-university"
      });
      this.contentHtml = info.data[0].html;
    },
    uploader(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = loader => {
        return new CkeditorUploadAdapter(loader);
      };
    },
    async submit() {
      await this.saveAboutUPM();
    },
    async saveAboutUPM() {
      const response = await new AboutsService().create({
        html: this.contentHtml,
        type: "methodology-university"
      });
      if (!response) return;
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("common.updated_sucess"),
        type: "success"
      });
    }
  }
};
</script>

<style scoped></style>
